import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DenunciandoPage } from './denunciando';

const routes: Routes = [
  {
    path: '',
    component: DenunciandoPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DenunciandoPageRoutingModule { }
